import React from 'react';
import { useDragLayer, XYCoord } from 'react-dnd';
import { marginLeft } from 'app/area/codetable/list/list-items/drag-and-drop/constants';
import styles from './code-drag-preview-item.scss';

const getItemStyles = (
  initialOffset: XYCoord | null,
  currentSourceOffset: XYCoord | null,
  clientOffset: XYCoord | null
) => {
  if (!initialOffset || !currentSourceOffset) {
    return {
      display: 'none'
    };
  }

  const { x, y } = clientOffset;
  const transform = `translate(${x - marginLeft}px, ${y}px)`;

  return {
    transform,
    WebkitTransform: transform
  };
};

export const CodeDragPreviewItem = ({ renderItem, itemType }) => {
  const {
    item,
    currentItemType,
    initialOffset,
    currentSourceOffset,
    isDragging,
    clientOffset
  } = useDragLayer((monitor) => ({
    item: monitor.getItem(),
    currentItemType: monitor.getItemType(),
    initialOffset: monitor.getInitialSourceClientOffset(),
    currentSourceOffset: monitor.getSourceClientOffset(),
    clientOffset: monitor.getClientOffset(),
    isDragging: monitor.isDragging()
  }));

  if (!isDragging || currentItemType !== itemType) {
    return null;
  }

  return <div className={styles.previewContainer}>
    <div style={getItemStyles(initialOffset, currentSourceOffset, clientOffset)}>
      {renderItem(item)}
    </div>
  </div>;
};
